export class InputSelector{
    #element
    #field
    #items
    #itemsContainer
    #noDataElement
    #selectedValue
    #selectedValueField

    get element(){
        return this.#element
    }

    get noDataElement(){
        return this.#noDataElement
    }

    get inputField(){
        return this.#field
    }

    get selectedValueField(){
        return this.#selectedValueField
    }

    get value(){
        return this.#selectedValue
    }

    get items(){
        return this.#items
    }

    constructor(elOrSelector){
		this.#element = typeof elOrSelector === 'string' ? document.querySelector(elOrSelector) : elOrSelector;
        this.#field = this.element.querySelector('.input-selector-field')
        this.#selectedValueField = this.element.querySelector('.input-selector-value')
        this.#itemsContainer = this.element.querySelector('.input-selector-data-list')
        this.#items = this.element.getElementsByClassName('input-selector-item')
        this.#noDataElement = this.element.querySelector('.input-selector-no-data-item')
        if(this.#field && this.#itemsContainer){
            if(this.#field.hasAttribute('data-selected-value') && this.#field.getAttribute('data-selected-value'))
                this.#selectedValue = this.#field.getAttribute('data-selected-value')
            this.#field.addEventListener('click', ev=>this.toggleList(true))
            this.#field.addEventListener('input', this.filterItems.bind(this))
            for(let item of this.#items){
                item.addEventListener('click', this.selectItem.bind(this))
            }
            document.addEventListener('click', ev=>{
                const isClickInside = this.#element.contains(ev.target);
                if (!isClickInside)
                    this.toggleList(false)
            });
        }
    }


    toggleList(active=true){
        if(active)
            this.#itemsContainer.classList.add('active')
        else
            this.#itemsContainer.classList.remove('active')
    }

    filterItems(){
        let escapeText = this.#field.value.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');
        let regex = new RegExp(`^${escapeText}`,'i')
        let visibleCount = 0
        for(let item of this.#items){
            if(regex.test(item.textContent)){
                item.classList.remove('hidden')
                visibleCount++
            }else{
                item.classList.add('hidden')
            } 
        }
        if(this.#noDataElement){
            if(visibleCount==0){
                let newEvent = new CustomEvent('no-data',{ detail: {value:this.#field.value}});
                this.#element.dispatchEvent(newEvent);
                this.#noDataElement.classList.remove('hidden')
            }else
                this.#noDataElement.classList.add('hidden')
        }
        
    }

    selectItem(ev){
        let el = ev.currentTarget
        if(!el.hasAttribute('data-value') || !el.getAttribute('data-value'))
            return
        let value = el.getAttribute('data-value')
        this.#field.setAttribute('data-selected-value', value)
        if(this.#selectedValueField)
            this.#selectedValueField.value = value
        this.#selectedValue = value
        this.#field.value = el.textContent
        this.toggleList(false)
        let newEvent = new CustomEvent('select-item',{ detail: {value}});
		this.#element.dispatchEvent(newEvent);
        this.filterItems()
    }
}